import script from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PodcastAdminShowsList.vue?vue&type=script&setup=true&lang=js"

import "./PodcastAdminShowsList.vue?vue&type=style&index=0&id=2de90c52&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2de90c52"]])

export default __exports__